import type { TreeDataNode } from 'antd'
import { RootCategory } from '../../services/models'

/**
 * Дерево каталога в одном месте: его показывают топ-меню и страница каталога.
 * Форма ключей общая, и на ней держится выбор узла: у категорий это их id,
 * у сервиса — готовый путь `/analytics/{id}`. По префиксу ключа сервис
 * и отличается от категории.
 */
export const SERVICE_KEY_PREFIX = '/analytics/'

export const isServiceKey = (key: string) => key.startsWith(SERVICE_KEY_PREFIX)

export const buildCatalogTreeData = (categories: RootCategory[]): TreeDataNode[] =>
  categories.map((c) => ({
    key: c.id.toString(),
    title: c.name,
    children: c.children.map((sc) => ({
      key: sc.id.toString(),
      title: sc.name,
      children: sc.services.map((s) => ({
        key: `${SERVICE_KEY_PREFIX}${s.id}`,
        title: s.name
      }))
    }))
  }))

// Категории и подкатегории раскрыты сразу: пользователь приходит за сервисом,
// и два лишних клика на путь к нему только мешают. Ключи сервисов в раскрытие
// не входят — у них не бывает потомков.
export const catalogExpandedKeys = (categories: RootCategory[]): string[] =>
  categories.flatMap((c) => [
    c.id.toString(),
    ...c.children.map((sc) => sc.id.toString())
  ])
